import { Divider, FormControl, FormLabel, Input, ModalBody, ModalFooter, Select, SimpleGrid, Switch } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import ColorPicker from 'components/ui/ColorPicker/ColorPicker';
import SubmitButton from 'components/ui/SubmitButton';
import { useContentGroup } from 'features/content-groups/hooks/useContentGroup';
import { useMessages } from 'hooks/useMessages';
import { FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { brandColorPalette } from 'theme/theme';
import ContentGroup from 'types/entities/content-group.entity';
import TemplateCategory from 'types/entities/template-category.entity';
import * as Yup from 'yup';
import { useTemplateCategoriesContext } from '../contexts/TemplateCategoriesContext';
import { CategoryInputs, useSaveTemplateCategory } from '../hooks/useSaveTemplateCategory';
interface FormCategoryWrapperProps {
  category?: TemplateCategory;
}

interface FormCategoryProps {
  category?: TemplateCategory;
  contentGroup: ContentGroup;
}

function FormCategory({ category, contentGroup }: FormCategoryProps) {
  const { modals } = useTemplateCategoriesContext();

  const isAgenda = contentGroup.type === 'AGENDA';

  let validations = {
    name: Yup.string().required(),
    contentGroupId: Yup.string().required(),
    color: Yup.string().optional(),
    subcategoryColor: Yup.string().optional(),
    highlightNoteColor: Yup.string().optional(),
  };

  let defaultValues: CategoryInputs = {
    name: category?.name || '',
    contentGroupId: contentGroup.id,
    active: category?.active
  };

  if (isAgenda) {
    validations = {
      ...validations,
      color: Yup.string().required(),
      subcategoryColor: Yup.string().required(),
      highlightNoteColor: Yup.string().required(),
    };

    defaultValues = {
      ...defaultValues,
      color: category?.color || '#79A22E',
      subcategoryColor: category?.subcategoryColor || '#416629',
      highlightNoteColor: category?.highlightNoteColor || '#F5FCE5',
    }
  }
  
  const validationSchema = Yup.object().shape(validations);

  const methods = useForm<CategoryInputs>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as Resolver<CategoryInputs>,
    defaultValues
  });

  const { register, watch, handleSubmit, setValue, reset, formState: { errors, isValid } } = methods;

  const [isActive] = watch(['active']);

  const { onError } = useMessages();

  const { 
    onSaveTemplateCategory, 
    isPending,
  } = useSaveTemplateCategory({ 
        categoryId: category?.id,
        contentGroupId: contentGroup.id,
        onSuccess: () => {
          reset();
          modals.category.onClose();
        },
        onError: (error) => onError(error?.response?.data?.message)
      });
    
  const onSubmit: SubmitHandler<CategoryInputs> = (data) => onSaveTemplateCategory(data);
  
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody minH={isAgenda ? '600px' : 'unset'}>
          <FormControl>
            <FormLabel>Modelo de disparo</FormLabel>
            <Select disabled>
              <option value={contentGroup.id}>{contentGroup.name}</option>
          </Select>
          
          </FormControl>
          <FormControl isInvalid={!!errors.name} isRequired>
            <FormLabel>Nome</FormLabel>
            <Input {...register('name')} />
          </FormControl>
        { category && (
          <FormControl isInvalid={!!errors.active}>
            <FormLabel>Status</FormLabel>
            <Switch {...register('active')}>
            { isActive ? 'Ativo' : 'Inativo' }
            </Switch>
          </FormControl>
        )}

        { isAgenda && (
          <>
            <Divider my="38px" />

            <FormControl isInvalid={!!errors.color} isRequired>
              <SimpleGrid columns={2}>
                <FormLabel>Cor de fundo da categoria</FormLabel>
                <ColorPicker 
                  colors={brandColorPalette}
                  defaultColor={defaultValues.color}
                  onColorChange={(color) => setValue('color', color.hex, { shouldValidate: true })}
                />
              </SimpleGrid>
            </FormControl>

            <FormControl isInvalid={!!errors.subcategoryColor} isRequired>
              <SimpleGrid columns={2}>
                <FormLabel>Cor de texto das subcategorias</FormLabel>
                <ColorPicker 
                  colors={brandColorPalette}
                  defaultColor={defaultValues.subcategoryColor}
                  onColorChange={(color) => setValue('subcategoryColor', color.hex, { shouldValidate: true })}
                />
              </SimpleGrid>
            </FormControl>

            <FormControl isInvalid={!!errors.highlightNoteColor} isRequired>
              <SimpleGrid columns={2}>
                <FormLabel>Cor de fundo da notas em destaque</FormLabel>
                <ColorPicker 
                  colors={brandColorPalette}
                  defaultColor={defaultValues.highlightNoteColor}
                  onColorChange={(color) => setValue('highlightNoteColor', color.hex, { shouldValidate: true })}
                />
              </SimpleGrid>
            </FormControl>
          </>
        )}
        </ModalBody>  
        <ModalFooter>
          <SubmitButton 
            isDisabled={isPending || !isValid}
            isLoading={isPending}
            hideIcon
          >
            { category ? 'Alterar' : 'Adicionar' }
          </SubmitButton>
        </ModalFooter>
      </form>
    </FormProvider>
  )
}

export default function FormCategoryWrapper({ category }: FormCategoryWrapperProps) {
  const { id } = useParams();
  const { data: contentGroup } = useContentGroup(id as string);

  if (!contentGroup)
    return null;
  console.log('contentGroup', contentGroup)
  return <FormCategory category={category} contentGroup={contentGroup as unknown as ContentGroup} />

}
